import { Box, Text, Icon } from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import { useContext } from "react";
import { BsFolderCheck } from "react-icons/bs";

const DashWidget = ({ title, count, link, props }: any) => {
  const { workFlowData } = useContext(AppContext);

  return (
    <Box
      mt="0.2rem"
      boxShadow="0 4px 15px rgba(0, 0, 0, 0.1)"
      p={{ base: "1rem", md: "1.8rem 1.4rem" }}
      rounded="2xl"
      textAlign="center"
      minH={{ base: "110px", md: "160px" }}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      cursor="pointer"
      border="1px solid rgba(255,255,255,0.15)"
      backdropFilter="blur(8px)"
      transition="all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)"
      _hover={{ 
        transform: "translateY(-6px) scale(1.02)", 
        boxShadow: "0 12px 28px rgba(0,0,0,0.25)",
        border: "1px solid rgba(255,255,255,0.3)"
      }}
      onClick={() => link && link()}
      {...props}
    >
      <Text
        fontSize={{ base: "xs", md: "sm" }}
        fontWeight="700"
        color="whiteAlpha.900"
        textTransform="uppercase"
        letterSpacing="0.8px"
        mb="0.3rem"
        noOfLines={2}
        opacity={0.95}
        textShadow="0px 1px 2px rgba(0,0,0,0.1)"
      >
        {title} {workFlowData?.documentType && (typeof workFlowData.documentType === 'object' ? workFlowData?.documentType?.label || workFlowData?.documentType?.value : workFlowData?.documentType)}
      </Text>

      {count || count === 0 ? (
        <Text
          fontSize={{ base: "2xl", md: "4xl" }}
          fontWeight="900"
          color="white"
          lineHeight="1.1"
          textShadow="0px 3px 6px rgba(0,0,0,0.2)"
        >
          {count}
        </Text>
      ) : (
        <Icon
          as={BsFolderCheck}
          w={7}
          h={7}
          color="whiteAlpha.900"
          opacity={0.95}
        />
      )}
    </Box>
  );
};

export default DashWidget;
